import { IBusLocation } from "@/domain/entities/lineInfo";
import { BusStopEventCode } from "@/types";
import { ref } from "vue";

export const useHasAllBusesArrivedLastStop = () => {
  const hasAllBusesArrivedLastStop = ref(false);

  const resetHasAllBusesArrivedLastStop = () => {
    hasAllBusesArrivedLastStop.value = false;
  };

  const updateHasAllBusesArrivedLastStop = (locations: IBusLocation[]) => {
    if (!locations.length) {
      hasAllBusesArrivedLastStop.value = false;
      return;
    }

    hasAllBusesArrivedLastStop.value = locations.every((location) => {
      const busStopEvents = location.busStopEvents;
      const lastStopEvent = busStopEvents[busStopEvents.length - 1];
      return (
        lastStopEvent.busStopEventCode === BusStopEventCode.Arrive ||
        lastStopEvent.busStopEventCode === BusStopEventCode.LastLeave
      );
    });
  };

  return {
    hasAllBusesArrivedLastStop,
    updateHasAllBusesArrivedLastStop,
    resetHasAllBusesArrivedLastStop,
  };
};
